<template>
    <div class="form-group" :class="model.size">
        <label class="font-weight-bold" :class="labelClasses" :for="'starRating' + _uid">
            {{ isEnVersion ? model.labelEn : model.label }}
        </label>
        <div aria-describedby="descriptionHelp">
            <star-rating v-model="model.fieldValue.intValue"
                         :id="'starRating' + _uid"
                         :name="'starRating' + _uid"
                         :class="model.fieldCode"
                         :star-size="30"
                         :max-rating="model.intMaxValue"
                         :show-rating="true"
                         :increment="1"
                         :round-start-rating="false"
                         :data-vv-as="model.label"
                         v-validate="validations"
                         :read-only="model.isReadOnly || details"
                         :clearable="true"
                         inline
                         @rating-selected="ratingSelected">
            </star-rating>
            <button class="btn btn-link btn-xm my-0 mt-1" v-if="model.fieldValue.intValue && !model.isReadOnly && !details"
                @click.stop="model.fieldValue.intValue = null">
                <i class="fas fa-times text-danger"></i>
            </button>
        </div>
        <small id="descriptionHelp" class="form-text text-muted">{{ isEnVersion ? model.descriptionEn : model.description }}</small>
        <div class="text-danger" v-if="errors.has('starRating' + _uid)">{{ errors.first('starRating' + _uid) }}</div>

    </div>
</template>

<script>
    import { EditorComponentModel } from '../../models/models';
    import StarRating from 'vue-star-rating';
    import { mapGetters } from 'vuex';
    import { RegisterEventBus } from '@/buses/register-bus.js';

    export default {
        inject: ['$validator'],
        props: {
            model: {
                type: EditorComponentModel
            },
            value: [String, Number],
            details: {
                type: Boolean,
                default: false
            },
            allowAnonymous: {
                type: Boolean,
                default: true
            },
            isEvaluationPanel: {
                type: Boolean,
                default: false
            }
        },
        components: {
            StarRating
        },
        data() {
            return {
                validations: '',
                labelClasses: '',
            }
        },
        methods: {
            addValidations() {
                if (this.model.isRequired) {
                    this.addValidation('required');
                    this.labelClasses += 'required';
                }

                this.addNumberValidations();
            },
            addValidation(validation) {
                if (this.validations.length > 0) {
                    this.validations += '|';
                }
                this.validations += validation;
            },
            addNumberValidations() {
                this.addIntValidations();
            },
            addIntValidations() {
                // https://mantis.kontrax.bg/view.php?id=12565
                // При незадължителни полета не трябва да се прави валидация на мин. / макс. стойност;
                if (this.model.isRequired) {
                    if (this.model.intMinValue && !isNaN(parseInt(this.model.intMinValue))) {
                        this.addValidation(`min_value:${this.model.intMinValue}`);
                    }
                    if (this.model.intMaxValue && !isNaN(parseInt(this.model.intMaxValue))) {
                        this.addValidation(`max_value:${this.model.intMaxValue}`);
                    }
                }
            },
            setInitialValue() {
                // 0012565: Полета тип „оценка“ и незадължителни полета
                // При попълване на полета тип „оценка“ не трябва да се взима дефолтната стойност на „int“;
                if (this.model.fieldValue.intValue === '') {
                    this.model.fieldValue.intValue = null;
                }
            },
            ratingSelected(value) {
                RegisterEventBus.$emit('dynamic-field-change', value, value, this.model);
                if (this.model.fieldValue.intValue < this.model.intMinValue) {
                    this.model.fieldValue.intValue = this.model.intMinValue;
                }
            }
        },
        created() {
            this.setInitialValue();
        },
        mounted() {
            this.addValidations();
            this.model.uid = this._uid;
            this.model.isEvaluationPanel = this.isEvaluationPanel;
        },
        computed: {
            ...mapGetters(['isEnVersion'])
        }
    }
</script>
